//# sourceMappingURL=tab_bar.mjs.map
/// <reference types="./tab_bar.d.mts" />
import * as $l from "../../ds/ds/components/layout.mjs";
import * as $tab_bar from "../../ds/ds/components/tab_bar.mjs";
import * as $cypress from "../../ds/ds/cypress.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $window from "../../magellan/magellan/window.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $attribute from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import {
  Ok,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../gleam.mjs";

const FILEPATH = "src/altar/tab_bar.gleam";

class None extends $CustomType {}

class Action extends $CustomType {
  constructor(child) {
    super();
    this.child = child;
  }
}

class Tab extends $CustomType {
  constructor(active, href, disabled, children) {
    super();
    this.active = active;
    this.href = href;
    this.disabled = disabled;
    this.children = children;
  }
}

export function tab(to, children) {
  let location = $window.location();
  let $ = $uri.parse(location);
  let current_uri;
  if ($ instanceof Ok) {
    current_uri = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "altar/tab_bar",
      20,
      "tab",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 447, end: 495, pattern_start: 458, pattern_end: 473 }
    )
  }
  let active = current_uri.path === to.path;
  let href = $uri.to_string(to);
  return new Tab(active, href, false, children);
}

export function disabled(tab, disabled) {
  if (tab instanceof None) {
    return tab;
  } else if (tab instanceof Action) {
    return tab;
  } else {
    return new Tab(tab.active, tab.href, disabled, tab.children);
  }
}

function actions(tabs) {
  return $list.map(
    tabs,
    (tab) => {
      if (tab instanceof None) {
        return $h.none();
      } else if (tab instanceof Action) {
        let child = tab.child;
        return child;
      } else {
        return $h.none();
      }
    },
  );
}

export function tab_bar(tabs) {
  return $l.row(
    toList([$l.align("center"), $l.shrink(0.0)]),
    toList([]),
    listPrepend(
      $tab_bar.tab_bar(
        toList([$cypress.data("tabs-navbar")]),
        $list.map(
          tabs,
          (tab) => {
            if (tab instanceof None) {
              return $h.none();
            } else if (tab instanceof Action) {
              return $h.none();
            } else {
              let active = tab.active;
              let href = tab.href;
              let disabled$1 = tab.disabled;
              let children = tab.children;
              let href$1 = $attribute.href(href);
              let disabled$2 = $attribute.attribute(
                "disabled",
                $bool.to_string(disabled$1),
              );
              return $tab_bar.tab(
                active,
                toList([href$1, disabled$2]),
                children,
              );
            }
          },
        ),
      ),
      actions(tabs),
    ),
  );
}

export function action(element) {
  return new Action(element);
}

export function none() {
  return new None();
}
